import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { http, euro, STATUS_LABEL, loginWithGoogle } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import { Rewards } from "@/components/site/Rewards";

export default function Account() {
  const { user, loading } = useAuth();
  const [orders, setOrders] = useState(null);

  useEffect(() => {
    if (!user) return;
    http.get("/me/orders").then((r) => setOrders(Array.isArray(r.data) ? r.data : [])).catch(() => setOrders([]));
  }, [user]);

  if (loading) return <div className="min-h-screen" />;
  if (!user)
    return (
      <div data-testid="account-login-required" className="mx-auto max-w-xl px-5 pt-40 pb-20 text-center">
        <h1 className="font-display text-4xl font-light">Votre espace <em className="italic text-[var(--terra)]">Kairos</em></h1>
        <p className="mt-4 text-[var(--muted)]">Connectez-vous pour retrouver vos commandes.</p>
        <button data-testid="account-login-button" onClick={loginWithGoogle}
          className="mt-8 rounded-full bg-[var(--ink)] px-8 py-4 text-sm text-[var(--bone)] hover:bg-[var(--terra)]">Continuer avec Google</button>
      </div>
    );

  return (
    <div data-testid="account-page" className="mx-auto max-w-3xl px-5 pt-[120px] pb-10 sm:px-10">
      <p className="font-mono-label text-[11px] text-[var(--muted)]">Mon compte</p>
      <h1 className="font-display mt-4 text-4xl sm:text-5xl font-light">Bonjour, <em className="italic text-[var(--terra)]">{user.name?.split(" ")[0]}</em>.</h1>
      {user.is_admin && (
        <Link to="/admin" data-testid="account-admin-link" className="mt-6 inline-block rounded-full border border-[var(--ink)] px-5 py-2 text-sm hover:bg-[var(--ink)] hover:text-[var(--bone)]">
          Ouvrir le tableau de bord propriétaire →
        </Link>
      )}
      <Rewards />
      <h2 className="font-display mt-14 text-2xl">Mes commandes</h2>
      {orders === null ? <p className="mt-6 text-[var(--muted)]">Chargement…</p> : orders.length === 0 ? (
        <p data-testid="account-no-orders" className="mt-6 text-[var(--muted)]">Aucune commande pour le moment.</p>
      ) : (
        <ul className="mt-6 divide-y divide-[var(--line)] border-y border-[var(--line)]">
          {orders.map((o) => (
            <li key={o.id} data-testid={`account-order-${o.id}`}>
              <Link to={`/commande/${o.id}`} className="flex items-center justify-between gap-4 py-5 hover:text-[var(--terra-deep)]">
                <div>
                  <p className="text-sm font-medium">N° {o.id.slice(-8).toUpperCase()} · {new Date(o.created_at).toLocaleDateString("fr-FR")}</p>
                  <p className="text-xs text-[var(--muted)]">{(o.lines ?? []).map((l) => l.name).join(", ")}</p>
                </div>
                <div className="text-right">
                  <p className="font-display text-lg">{euro(o.total)}</p>
                  <p className="text-xs text-[var(--muted)]">{STATUS_LABEL[o.status]}</p>
                </div>
              </Link>
            </li>
          ))}
        </ul>
      )}
    </div>
  );
}
